<script lang="ts">
import Vue from 'vue';
import JoinHeadingModuleStyle from './JoinHeading.module.scss';

export default Vue.extend({
  props: {
    level: {
      type: Number,
      required: true,
    },
  },
  render(h) {
    const level = this.level;

    const headingClass = [
      JoinHeadingModuleStyle.heading,
      JoinHeadingModuleStyle[`heading${level}`],
    ];
    const headingTag = `h${level}`;

    return h(headingTag, {
      class: headingClass,
    }, this.$slots.default);
  },
});
</script>
